module.exports = __webpack_public_path__ + "static/media/handball.acce562b.jpg";